module.exports = __webpack_public_path__ + "static/img/152_TO8_1868_og.0bf5fd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/152_TO8_1868_og.jpg
// module id = W2Go
// module chunks = 0